export const colors = {
  purple: '#bf00ff',
  brown: '#c9b18aff',
  red: '#c9b18aff',
  blue: '#4b61d1',
  pink: '#f500ff',
  lightBlue: '#347e8aff',
  darkBlue: '#29576eff',
  gray: '#5b778fff',
  lightGray: '#F3F5F7',
  green: '#7DDE92',
  secondary: '#6c757d',
  componentBackground: '#1f1f1f',
};

export const textSizes = {
  t0: '48px',
  t1: '36px',
  t2: '26px',
  t3: '22px',
  t4: '18px',
  t5: '16px',
  t6: '14px',
};

const theme = {
  ...colors,
  textSizes,
};

export default theme;
